// import React, { useEffect, useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom'
// import { useGoogleLogin } from '@react-oauth/google';
// import SignInForm from "./SignInForm";
// import { ConstructorEventPost, ConstructorEventGetNoParams } from '../../Event/event';
// import { CheckUserDetailsForSignIn } from '../../api/aws-api';
// import { toast } from 'react-toastify';


// function SignIn(props) {
//   const navigate = useNavigate()
//   const [showOtpColoumn, setShowOtpColoumn] = useState(false)
//   const [proceedLoading, setProceedLoading] = useState(false)
//   const [usedGoogle, setUsedGoogle] = useState(false)


//   const notify = (message) => toast.error(message, {
//     className: 'my-custom-toast',
//     position: "top-left",
//     autoClose: 10000,
//     hideProgressBar: false,
//     pauseOnHover: true,
//     progress: undefined,
//     theme: "light",
//   });;
//   const login = useGoogleLogin({
//     onSuccess: (codeResponse) => fetchdatafromgoogleapis(codeResponse),
//     onError: (error) => console.log('Login Failed:', error)
//   });

//   useEffect(() => {
//     document.documentElement.scrollTop = 0;
//   }, []);

//   const FetchData = async (data) => {
//   setProceedLoading(true)
//   const responsedata = await ConstructorEventPost(CheckUserDetailsForSignIn, data)
//   console.log("data", data)
//   if (data.resendOtp) {
//     console.log("Resend OTP event detected.");
//   }

//   console.log("Responsedata", responsedata)

//   // ── NEW: handle the dict-shaped responses (otp-verified / googleId-verified) ──
//   if (responsedata?.status === "otp-verified" || responsedata?.status === "googleId-verified") {
//     localStorage.removeItem("plivo_session_uid")
//     localStorage.setItem('authToken', responsedata.SecretKey)
//     localStorage.setItem('lastLoginTime', Date.now())
//     localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
//     navigate("/codomo/home")
//     setProceedLoading(false)
//     setUsedGoogle(false)
//     return
//   }

//   // ── EXISTING: old string/tuple-shaped responses (unchanged) ──────────────────
//   const session_uuid = responsedata[1]
//     localStorage.setItem("session_uuid", session_uuid);
//     if (responsedata[0] === "user-verified") {
//       const session_uuid = responsedata[1]
//       localStorage.setItem("plivo_session_uid", session_uuid)
//     }
//     if (responsedata[0] === "user-verified") { setShowOtpColoumn(responsedata) }
//     else if (responsedata === "user-verified") { setShowOtpColoumn(responsedata) }
//     else if (responsedata === "otp-verification-failed") { notify("Otp Verification Failed") }
//     else if (responsedata === "user-not-active") { notify("User is not Active") }
//     else if (responsedata === "user-verification-failed") { notify("Sorry, it looks like we can't find your account! Click 'let's get started' to join our platform."); navigate('/signUp') }
//     else if (responsedata === "otp-expired") { notify("Otp is Expired") }
//     else if (responsedata[0] === "email-verification-pending") {
//       notify("Please Verify Your Mail")
//       localStorage.setItem('UserKey', JSON.stringify(responsedata[1])); navigate('/confirmemail')
//     }
//     else if (responsedata === "user-verified") {
//       localStorage.setItem('authToken', responsedata[2]); localStorage.setItem('lastLoginTime', Date.now()); navigate("/codomo/home")
//       localStorage.setItem('UserKey', JSON.stringify(responsedata[1]))
//     }

//     setProceedLoading(false)
//     setUsedGoogle(false)
//   }
//   return (
//     <>
//       <SignInForm GoogleLoginFunction={login} FetchData={FetchData}
//         showOtpColoumn={showOtpColoumn} proceedLoading={proceedLoading}
//         setShowOtpColoumn={setShowOtpColoumn} usedGoogle={usedGoogle}
//       />
//     </>
//   );
// }

// export default SignIn;

















// import React, { useEffect, useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom'
// import { useGoogleLogin } from '@react-oauth/google';
// import SignInForm from "./SignInForm";
// import { ConstructorEventPost, ConstructorEventGetNoParams } from '../../Event/event';
// import { CheckUserDetailsForSignIn } from '../../api/aws-api';
// import { toast } from 'react-toastify';
// import axios from 'axios';


// function SignIn(props) {
//   const navigate = useNavigate()
//   const [showOtpColoumn, setShowOtpColoumn] = useState(false)
//   const [proceedLoading, setProceedLoading] = useState(false)
//   const [usedGoogle, setUsedGoogle] = useState(false)


//   const notify = (message) => toast.error(message, {
//     className: 'my-custom-toast',
//     position: "top-left",
//     autoClose: 10000,
//     hideProgressBar: false,
//     pauseOnHover: true,
//     progress: undefined,
//     theme: "light",
//   });;
//   const fetchdatafromgoogleapis = async (codeResponse) => {
//     setUsedGoogle(true)
//     try {
//       const res = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
//         headers: { Authorization: `Bearer ${codeResponse.access_token}` }
//       })
//       const email = res.data.email
//       const googleId = res.data.sub
//       await FetchData({ emailOrPhone: email.toLowerCase(), googleId })
//     } catch (error) {
//       console.error(error)
//       notify('Google Sign-In Failed. Please try again.')
//       setUsedGoogle(false)
//     }
//   }

//   const login = useGoogleLogin({
//     onSuccess: (codeResponse) => fetchdatafromgoogleapis(codeResponse),
//     onError: (error) => console.log('Login Failed:', error)
//   });

//   useEffect(() => {
//     document.documentElement.scrollTop = 0;
//   }, []);


//   // In SignIn.jsx - Fix the FetchData function:

// const FetchData = async (data) => {
//   setProceedLoading(true);
//   try {
//     const responsedata = await ConstructorEventPost(CheckUserDetailsForSignIn, data);
//     console.log("Responsedata", responsedata);

//     const status = responsedata?.status;

//     if (status === "otp-verified" || status === "googleId-verified") {
//       // Save session data
//       localStorage.removeItem("plivo_session_uid");
//       localStorage.setItem('authToken', responsedata.SecretKey);
//       localStorage.setItem('lastLoginTime', Date.now().toString());
//       localStorage.setItem('UserKey', JSON.stringify(responsedata.user));
      
//       // Clear any previous state
//       setShowOtpColoumn(false);
      
//       // Navigate to home
//       window.location.href = "/codomo/home";
//       // navigate("/codomo/home");
//     }
//     else if (status === "user-verified") {
//       setShowOtpColoumn(true);
//     }
//     else if (status === "otp-verification-failed") {
//       notify("Otp Verification Failed");
//     }
//     else if (status === "user-not-active") {
//       notify("User is not Active");
//     }
//     else if (status === "user-verification-failed") {
//       notify("Sorry, it looks like we can't find your account! Click 'let's get started' to join our platform.");
//       navigate('/signUp');
//     }
//     else if (status === "otp-expired") {
//       notify("Otp is Expired");
//     }
//     else if (status === "email-verification-pending") {
//       notify("Please Verify Your Mail");
//       if (responsedata.user) {
//         localStorage.setItem('UserKey', JSON.stringify(responsedata.user));
//       }
//       navigate('/confirmemail');
//     }
//     else if (status === "payment-pending") {
//       notify(responsedata.message || "Please complete your course payment to sign in.");
//     }
//     else if (status === "otp_sending_failed" || status === "server-error") {
//       notify(responsedata?.message || "Something went wrong. Please try again.");
//     }
//   } catch (error) {
//     console.error("SignIn error:", error);
//     notify("Something went wrong. Please try again.");
//   } finally {
//     setProceedLoading(false);
//     setUsedGoogle(false);
//   }
// };

//   // const FetchData = async (data) => {
//   //   setProceedLoading(true)
//   //   const responsedata = await ConstructorEventPost(CheckUserDetailsForSignIn, data)
//   //   console.log("data", data)
//   //   if (data.resendOtp) {
//   //     console.log("Resend OTP event detected.");
//   //   }

//   //   console.log("Responsedata", responsedata)

//   //   const status = responsedata?.status

//   //   if (status === "otp-verified" || status === "googleId-verified") {
//   //     localStorage.removeItem("plivo_session_uid")
//   //     localStorage.setItem('authToken', responsedata.SecretKey)
//   //     localStorage.setItem('lastLoginTime', Date.now())
//   //     localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
//   //     navigate("/codomo/home")
//   //   }
//   //   else if (status === "user-verified") {
//   //     setShowOtpColoumn(true)
//   //   }
//   //   else if (status === "otp-verification-failed") {
//   //     notify("Otp Verification Failed")
//   //   }
//   //   else if (status === "user-not-active") {
//   //     notify("User is not Active")
//   //   }
//   //   else if (status === "user-verification-failed") {
//   //     notify("Sorry, it looks like we can't find your account! Click 'let's get started' to join our platform.")
//   //     navigate('/signUp')
//   //   }
//   //   else if (status === "otp-expired") {
//   //     notify("Otp is Expired")
//   //   }
//   //   else if (status === "email-verification-pending") {
//   //     notify("Please Verify Your Mail")
//   //     if (responsedata.user) {
//   //       localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
//   //     }
//   //     navigate('/confirmemail')
//   //   }
//   //   else if (status === "payment-pending") {
//   //     notify(responsedata.message || "Please complete your course payment to sign in.")
//   //   }
//   //   else if (status === "otp_sending_failed" || status === "server-error") {
//   //     notify(responsedata?.message || "Something went wrong. Please try again.")
//   //   }

//   //   setProceedLoading(false)
//   //   setUsedGoogle(false)
//   // }

//   return (
//     <>
//       <SignInForm GoogleLoginFunction={login} FetchData={FetchData}
//         showOtpColoumn={showOtpColoumn} proceedLoading={proceedLoading}
//         setShowOtpColoumn={setShowOtpColoumn} usedGoogle={usedGoogle}
//       />
//     </>
//   );
// }

// export default SignIn;

































// import React, { useEffect, useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom'
// import { useGoogleLogin } from '@react-oauth/google';
// import SignInForm from "./SignInForm";
// import { ConstructorEventPost, ConstructorEventGetNoParams } from '../../Event/event';
// import { CheckUserDetailsForSignIn } from '../../api/aws-api';
// import { toast } from 'react-toastify';
// import axios from 'axios';


// function SignIn(props) {
//   const navigate = useNavigate()
//   const [showOtpColoumn, setShowOtpColoumn] = useState(false)
//   const [proceedLoading, setProceedLoading] = useState(false)
//   const [usedGoogle, setUsedGoogle] = useState(false)


//   const notify = (message) => toast.error(message, {
//     className: 'my-custom-toast',
//     position: "top-left",
//     autoClose: 10000,
//     hideProgressBar: false,
//     pauseOnHover: true,
//     progress: undefined,
//     theme: "light",
//   });;
//   const fetchdatafromgoogleapis = async (codeResponse) => {
//     setUsedGoogle(true)
//     try {
//       const res = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
//         headers: { Authorization: `Bearer ${codeResponse.access_token}` }
//       })
//       const email = res.data.email
//       const googleId = res.data.sub
//       await FetchData({ emailOrPhone: email.toLowerCase(), googleId })
//     } catch (error) {
//       console.error(error)
//       notify('Google Sign-In Failed. Please try again.')
//       setUsedGoogle(false)
//     }
//   }

//   const login = useGoogleLogin({
//     onSuccess: (codeResponse) => fetchdatafromgoogleapis(codeResponse),
//     onError: (error) => console.log('Login Failed:', error)
//   });

//   useEffect(() => {
//     document.documentElement.scrollTop = 0;
//   }, []);

//   const FetchData = async (data) => {
//     setProceedLoading(true)
//     const responsedata = await ConstructorEventPost(CheckUserDetailsForSignIn, data)
//     console.log("data", data)
//     if (data.resendOtp) {
//       console.log("Resend OTP event detected.");
//     }

//     console.log("Responsedata", responsedata)

//     const status = responsedata?.status

//     if (status === "otp-verified" || status === "googleId-verified") {
//       localStorage.removeItem("plivo_session_uid")
//       localStorage.setItem('authToken', responsedata.SecretKey)
//       localStorage.setItem('lastLoginTime', Date.now())
//       localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
//       navigate("/codomo/home")
//     }
//     else if (status === "user-verified") {
//       setShowOtpColoumn(true)
//     }
//     else if (status === "otp-verification-failed") {
//       notify("Otp Verification Failed")
//     }
//     else if (status === "user-not-active") {
//       notify("User is not Active")
//     }
//     else if (status === "user-verification-failed") {
//       notify("Sorry, it looks like we can't find your account! Click 'let's get started' to join our platform.")
//       navigate('/signUp')
//     }
//     else if (status === "otp-expired") {
//       notify("Otp is Expired")
//     }
//     else if (status === "email-verification-pending") {
//       notify("Please Verify Your Mail")
//       if (responsedata.user) {
//         localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
//       }
//       navigate('/confirmemail')
//     }
//     else if (status === "payment-pending") {
//       notify(responsedata.message || "Please complete your course payment to sign in.")
//     }
//     else if (status === "otp_sending_failed" || status === "server-error") {
//       notify(responsedata?.message || "Something went wrong. Please try again.")
//     }

//     setProceedLoading(false)
//     setUsedGoogle(false)
//   }

//   return (
//     <>
//       <SignInForm GoogleLoginFunction={login} FetchData={FetchData}
//         showOtpColoumn={showOtpColoumn} proceedLoading={proceedLoading}
//         setShowOtpColoumn={setShowOtpColoumn} usedGoogle={usedGoogle}
//       />
//     </>
//   );
// }

// export default SignIn;






















// import React, { useEffect, useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom'
// import { useGoogleLogin } from '@react-oauth/google';
// import SignInForm from "./SignInForm";
// import { ConstructorEventPost, ConstructorEventGetNoParams } from '../../Event/event';
// import { CheckUserDetailsForSignIn } from '../../api/aws-api';
// import { toast } from 'react-toastify';
// import axios from 'axios';


// function SignIn(props) {
//   const navigate = useNavigate()
//   const [showOtpColoumn, setShowOtpColoumn] = useState(false)
//   const [proceedLoading, setProceedLoading] = useState(false)
//   const [usedGoogle, setUsedGoogle] = useState(false)


//   const notify = (message) => toast.error(message, {
//     className: 'my-custom-toast',
//     position: "top-left",
//     autoClose: 10000,
//     hideProgressBar: false,
//     pauseOnHover: true,
//     progress: undefined,
//     theme: "light",
//   });;
//   const fetchdatafromgoogleapis = async (codeResponse) => {
//     try {
//       const res = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
//         headers: { Authorization: `Bearer ${codeResponse.access_token}` }
//       })
//       const email = res.data.email
//       const googleId = res.data.sub
//       await FetchData({ emailOrPhone: email.toLowerCase(), googleId })
//     } catch (error) {
//       console.error(error)
//       notify('Google Sign-In Failed. Please try again.')
//       setUsedGoogle(false)
//     }
//   }

//   const login = useGoogleLogin({
//     onSuccess: (codeResponse) => fetchdatafromgoogleapis(codeResponse),
//     onError: (error) => {
//       console.log('Login Failed:', error);
//       setUsedGoogle(false);
//     }
//   });

//   // Guards the window between the click and the OAuth popup resolving.
//   // usedGoogle previously only flipped true inside fetchdatafromgoogleapis
//   // (after the popup closed), leaving the button clickable while the
//   // popup was open — a second click there fired a second sign-in flow,
//   // each overwriting the DB's SecretKey and racing with the other's
//   // response, which is what caused intermittent authentication_failed.
//   const handleGoogleLogin = () => {
//     if (usedGoogle) return;
//     setUsedGoogle(true);
//     login();
//   };

//   useEffect(() => {
//     document.documentElement.scrollTop = 0;
//   }, []);

//   const FetchData = async (data) => {
//     setProceedLoading(true)
//     const responsedata = await ConstructorEventPost(CheckUserDetailsForSignIn, data)
//     console.log("data", data)
//     if (data.resendOtp) {
//       console.log("Resend OTP event detected.");
//     }

//     console.log("Responsedata", responsedata)

//     const status = responsedata?.status

//     if (status === "otp-verified" || status === "googleId-verified") {
//       localStorage.removeItem("plivo_session_uid")
//       localStorage.setItem('authToken', responsedata.SecretKey)
//       localStorage.setItem('lastLoginTime', Date.now())
//       localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
//       navigate("/codomo/home")
//     }
//     else if (status === "user-verified") {
//       setShowOtpColoumn(true)
//     }
//     else if (status === "otp-verification-failed") {
//       notify("Otp Verification Failed")
//     }
//     else if (status === "user-not-active") {
//       notify("User is not Active")
//     }
//     else if (status === "user-verification-failed") {
//       notify("Sorry, it looks like we can't find your account!")
//       // navigate('/signUp')
//     }
//     else if (status === "otp-expired") {
//       notify("Otp is Expired")
//     }
//     // else if (status === "email-verification-pending") {
//     //   notify("Please Verify Your Mail")
//     //   if (responsedata.user) {
//     //     localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
//     //   }
//     //   // navigate('/confirmemail')
//     // }
//     else if (status === "email-verification-pending") {
//       notify("Sorry, it looks like we can't find your account!")
//       if (responsedata.user) {
//         localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
//       }
//       // navigate('/confirmemail')
//     }
//     else if (status === "payment-pending") {
//       notify(responsedata.message || "Please complete your course payment to sign in.")
//     }
//     else if (status === "otp_sending_failed" || status === "server-error") {
//       notify(responsedata?.message || "Something went wrong. Please try again.")
//     }

//     setProceedLoading(false)
//     setUsedGoogle(false)
//   }

//   return (
//     <>
//       <SignInForm GoogleLoginFunction={handleGoogleLogin} FetchData={FetchData}
//         showOtpColoumn={showOtpColoumn} proceedLoading={proceedLoading}
//         setShowOtpColoumn={setShowOtpColoumn} usedGoogle={usedGoogle}
//       />
//     </>
//   );
// }

// export default SignIn;



























import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom'
import { useGoogleLogin } from '@react-oauth/google';
import SignInForm from "./SignInForm";
import { ConstructorEventPost, ConstructorEventGetNoParams } from '../../Event/event';
import { CheckUserDetailsForSignIn } from '../../api/aws-api';
import { toast } from 'react-toastify';
import axios from 'axios';


function SignIn(props) {
  const navigate = useNavigate()
  const [showOtpColoumn, setShowOtpColoumn] = useState(false)
  const [proceedLoading, setProceedLoading] = useState(false)
  const [usedGoogle, setUsedGoogle] = useState(false)


  const notify = (message) => toast.error(message, {
    className: 'my-custom-toast',
    position: "top-left",
    autoClose: 10000,
    hideProgressBar: false,
    pauseOnHover: true,
    progress: undefined,
    theme: "light",
  });;
  const fetchdatafromgoogleapis = async (codeResponse) => {
    try {
      const res = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
        headers: { Authorization: `Bearer ${codeResponse.access_token}` }
      })
      const email = res.data.email
      const googleId = res.data.sub
      await FetchData({ emailOrPhone: email.toLowerCase(), googleId })
    } catch (error) {
      console.error(error)
      notify('Google Sign-In Failed. Please try again.')
      setUsedGoogle(false)
    }
  }

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => fetchdatafromgoogleapis(codeResponse),
    onError: (error) => {
      console.log('Login Failed:', error);
      setUsedGoogle(false);
    }
  });

  // Guards the window between the click and the OAuth popup resolving.
  const handleGoogleLogin = () => {
    if (usedGoogle) return;
    setUsedGoogle(true);
    login();
  };

  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, []);

  // CHANGED — the lambda does NOT return a uniform {status, user, SecretKey}
  // object. Its shape depends on the branch it hit:
  //   - Array [status, user, SecretKey]  -> "otp-verified" / "googleId-verified"
  //   - Array [status, message]          -> "payment-pending"
  //   - Plain string "status-name"       -> every other status
  //   - Object {"error": message}        -> unhandled exception
  // This block normalizes all four shapes into (status, user, secretKey, message)
  // before running the same branching logic as before.
  const parseResponse = (responsedata) => {
    let status, user, secretKey, message

    if (Array.isArray(responsedata)) {
      status = responsedata[0]
      if (status === "otp-verified" || status === "googleId-verified") {
        user = responsedata[1]
        secretKey = responsedata[2]
      } else if (status === "payment-pending") {
        message = responsedata[1]
      }
    } else if (typeof responsedata === "string") {
      status = responsedata
    } else if (responsedata && typeof responsedata === "object") {
      if (responsedata.error) {
        status = "server-error"
        message = responsedata.error
      } else if (responsedata.status) {
        // in case any branch ever does return an object, don't break on it
        status = responsedata.status
        user = responsedata.user
        secretKey = responsedata.SecretKey
        message = responsedata.message
      }
    }

    return { status, user, secretKey, message }
  }

  const FetchData = async (data) => {
    setProceedLoading(true)
    const responsedata = await ConstructorEventPost(CheckUserDetailsForSignIn, data)
    console.log("data", data)
    if (data.resendOtp) {
      console.log("Resend OTP event detected.");
    }

    console.log("Responsedata", responsedata)

    const { status, user, secretKey, message } = parseResponse(responsedata)

    if (status === "otp-verified" || status === "googleId-verified") {
      localStorage.removeItem("plivo_session_uid")
      localStorage.setItem('authToken', secretKey)
      localStorage.setItem('lastLoginTime', Date.now())
      localStorage.setItem('UserKey', JSON.stringify(user))
      navigate("/codomo/home")
    }
    else if (status === "user-verified") {
      setShowOtpColoumn(true)
    }
    else if (status === "otp-verification-failed") {
      notify("Otp Verification Failed")
    }
    else if (status === "user-not-active") {
      notify("User is not Active")
    }
    else if (status === "user-verification-failed") {
      notify("Sorry, it looks like we can't find your account!")
      // navigate('/signUp')
    }
    else if (status === "otp-expired") {
      notify("Otp is Expired")
    }
    else if (status === "email-verification-pending") {
      notify("Sorry, it looks like we can't find your account!")
      // navigate('/confirmemail')
    }
    else if (status === "payment-pending") {
      notify(message || "Please complete your course payment to sign in.")
    }
    else if (status === "otp_sending_failed" || status === "server-error") {
      notify(message || "Something went wrong. Please try again.")
    }

    setProceedLoading(false)
    setUsedGoogle(false)
  }

  return (
    <>
      <SignInForm GoogleLoginFunction={handleGoogleLogin} FetchData={FetchData}
        showOtpColoumn={showOtpColoumn} proceedLoading={proceedLoading}
        setShowOtpColoumn={setShowOtpColoumn} usedGoogle={usedGoogle}
      />
    </>
  );
}

export default SignIn;







































// import React, { useEffect, useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom'
// import { useGoogleLogin } from '@react-oauth/google';
// import SignInForm from "./SignInForm";
// import { ConstructorEventPost, ConstructorEventGetNoParams } from '../../Event/event';
// import { CheckUserDetailsForSignIn } from '../../api/aws-api';
// import { toast } from 'react-toastify';
// import axios from 'axios';


// function SignIn(props) {
//   const navigate = useNavigate()
//   const [showOtpColoumn, setShowOtpColoumn] = useState(false)
//   const [proceedLoading, setProceedLoading] = useState(false)
//   const [usedGoogle, setUsedGoogle] = useState(false)


//   const notify = (message) => toast.error(message, {
//     className: 'my-custom-toast',
//     position: "top-left",
//     autoClose: 10000,
//     hideProgressBar: false,
//     pauseOnHover: true,
//     progress: undefined,
//     theme: "light",
//   });;
//   const fetchdatafromgoogleapis = async (codeResponse) => {
//     try {
//       const res = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
//         headers: { Authorization: `Bearer ${codeResponse.access_token}` }
//       })
//       const email = res.data.email
//       const googleId = res.data.sub
//       await FetchData({ emailOrPhone: email.toLowerCase(), googleId })
//     } catch (error) {
//       console.error(error)
//       notify('Google Sign-In Failed. Please try again.')
//       setUsedGoogle(false)
//     }
//   }

//   const login = useGoogleLogin({
//     onSuccess: (codeResponse) => fetchdatafromgoogleapis(codeResponse),
//     onError: (error) => {
//       console.log('Login Failed:', error);
//       setUsedGoogle(false);
//     }
//   });

//   // Guards the window between the click and the OAuth popup resolving.
//   const handleGoogleLogin = () => {
//     if (usedGoogle) return;
//     setUsedGoogle(true);
//     login();
//   };

//   useEffect(() => {
//     document.documentElement.scrollTop = 0;
//   }, []);

//   const FetchData = async (data) => {
//     setProceedLoading(true)
//     const responsedata = await ConstructorEventPost(CheckUserDetailsForSignIn, data)
//     console.log("data", data)
//     if (data.resendOtp) {
//       console.log("Resend OTP event detected.");
//     }

//     console.log("Responsedata", responsedata)

//     // CHANGED — lambda now always returns a uniform 3-element array:
//     // [status, extra, secretKey]. extra is the user object for verified
//     // logins, a message string for payment-pending/errors, or null.
//     const [status, extra, secretKey] = responsedata || []

//     if (status === "otp-verified" || status === "googleId-verified") {
//       localStorage.removeItem("plivo_session_uid")
//       localStorage.setItem('authToken', secretKey)
//       localStorage.setItem('lastLoginTime', Date.now())
//       localStorage.setItem('UserKey', JSON.stringify(extra))
//       navigate("/codomo/home")
//     }
//     else if (status === "user-verified") {
//       setShowOtpColoumn(true)
//     }
//     else if (status === "otp-verification-failed") {
//       notify("Otp Verification Failed")
//     }
//     else if (status === "user-not-active") {
//       notify("User is not Active")
//     }
//     else if (status === "user-verification-failed") {
//       notify("Sorry, it looks like we can't find your account!")
//       // navigate('/signUp')
//     }
//     else if (status === "otp-expired") {
//       notify("Otp is Expired")
//     }
//     else if (status === "email-verification-pending") {
//       notify("Sorry, it looks like we can't find your account!")
//       // navigate('/confirmemail')
//     }
//     else if (status === "payment-pending") {
//       notify(extra || "Please complete your course payment to sign in.")
//     }
//     else if (status === "otp_sending_failed" || status === "server-error") {
//       notify(extra || "Something went wrong. Please try again.")
//     }

//     setProceedLoading(false)
//     setUsedGoogle(false)
//   }

//   return (
//     <>
//       <SignInForm GoogleLoginFunction={handleGoogleLogin} FetchData={FetchData}
//         showOtpColoumn={showOtpColoumn} proceedLoading={proceedLoading}
//         setShowOtpColoumn={setShowOtpColoumn} usedGoogle={usedGoogle}
//       />
//     </>
//   );
// }

// export default SignIn;